import { Table as BaseTable, TableProps } from '@/components/table'
import { Query } from './table_query'
import { TaxRatesQuery } from './__generated__/table_query'
import { useQuery } from '@apollo/client'
import { Inline as Error } from '@/components/error'
import { Inline as Loading } from '@/components/loading'
import { VehicleFilters } from '@/types'
import { useTable } from '@/helpers/useTable'
import { Button } from '../base/button'
import { dedupe } from '@/helpers/dedupe'
import { NewDialog } from './new_dialog'
import { EditDialog } from './edit_dialog'

interface Props extends TableProps {
  createable?: boolean
}

export const Table = ({ pageSize = 20, onIndex = false, createable = false, ...props }: Props) => {
  const { data, loading, error, refetch, fetchMore } = useQuery<TaxRatesQuery>(
    Query,
    { variables: { first: pageSize } }
  )
  const { pageInfo, setOpenNew, openShow, openNew, showShow, hideShow, resourceId } = useTable({ pageInfo: data?.taxRates.pageInfo, onIndex, basePath: '/settings/tax-rates' })

  if (error) { return <Error message={error.message} /> }
  if (loading || !data) { return <Loading /> }

  return (
    <>
      <BaseTable<VehicleFilters>
        {...props}
        actionButton={createable ? <Button color="green" onClick={() => setOpenNew(true)}>Add</Button> : undefined}
        headings={[{ name: 'Name' }, { name: 'Rate' }, { name: '' }]}
        moreToFetch={pageInfo.current?.hasNextPage}
        refetch={refetch}
        fetchMore={() => fetchMore({
          variables: { after: pageInfo.current?.endCursor },
          updateQuery(previousData, { fetchMoreResult }) {
            if (Object.keys(previousData).length === 0) return fetchMoreResult
            fetchMoreResult.taxRates.nodes = dedupe([
              ...previousData.taxRates.nodes,
              ...fetchMoreResult.taxRates.nodes
            ])
            return { ...fetchMoreResult }
          }
        })}
        filters={[
          {
            index: 0,
            setValue: (set, value) => set(f => ({ ...f, nameCont: value })),
            type: 'text',
            placeholder: 'Now, what did we call it?'
          },
        ]}
        rows={data.taxRates.nodes.map(tr => (
          {
            id: tr.id,
            columns: [
              tr.name,
              tr.rate + '%'
            ]
          }
        ))}
        onRowClick={showShow}
      />
      { resourceId && <EditDialog id={resourceId} open={openShow} setOpen={hideShow} /> }

      <NewDialog open={openNew} setOpen={setOpenNew} />
    </>
  )
}
